import { fetchFamilyKeySellingPoints } from '@gn-audio/core/api/product-catalogue/fetch-family-key-selling-points';
import { fetchGroupKeySellingPoints } from '@gn-audio/core/api/product-catalogue/fetch-group-key-selling-points';
export var fetchKeySellingPoints = function (productId, productType, mode) {
    if (productType === void 0) { productType = "f" /* Family */; }
    var promise;
    switch (productType) {
        case "g" /* Group */:
            promise = fetchGroupKeySellingPoints(productId, mode);
            break;
        case "f" /* Family */:
        default:
            promise = fetchFamilyKeySellingPoints(productId, mode);
            break;
    }
    return promise;
};
